export const REQUEST_SUMMARYDATA = 'REQUEST_SUMMARYDATA';
export const SUMMARYDATA_RECEIVED = 'SUMMARYDATA_RECEIVED';
export const EDIT_SUMMARYDATA = 'EDIT_SUMMARYDATA';
export const CLEAR_SUMMARYDATA = 'CLEAR_SUMMARYDATA';
